import { getAllLanguage, getLanguageById, getLanguage } from '@/api/language.service.js'

export default {
  state: {
    language:{},
    languages:[]
  },
  getters: {
    getlanguage(state){
      return state.language
    },
    getAlllanguage(state){
      return state.languages
    }
  },
  mutations: {
    setLanguages(state, langs){
      state.languages = langs
    },
    setLanguageById(state, lang){
      state.language = lang
    }
  },
  actions: {
    async setLanguages(context){
      let langs = await getAllLanguage()
      context.commit('setLanguages', langs)
    },
    async setLanguageById(context, id){
      let lang = await getLanguageById(id)
      context.commit('setLanguageById', lang)
    }
  }
}


// WEBPACK FOOTER //
// ./src/store/language.store.js